import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandleService } from '../services/error-handle.service';
import { TenantBuildingResponse, TenantContractReferenceResponse, TenantDetailResponse, TenantListResponse } from '../models/tenant';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }


  getTenantList(
    page: number = 1,
    perPage: number = 8,
    search?: string,
    startDate?: string,
    endDate?: string
  ): Observable<TenantListResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<TenantListResponse>(`${this.apiUrl}office_lease/tenants`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getTenantListGroup(
    page: number = 1,
    perPage: number = 8,
    search?: string,
    startDate?: string,
    endDate?: string,
    tenantType: number = 1
  ): Observable<TenantListResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (tenantType) {
      params = params.set('tenantType', tenantType);
    }

    return this.http.get<TenantListResponse>(`${this.apiUrl}office_lease/tenants`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getTenantListNonGroup(
    page: number = 1,
    perPage: number = 8,
    search?: string,
    startDate?: string,
    endDate?: string,
    tenantType: number = 2
  ): Observable<TenantListResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (tenantType) {
      params = params.set('tenantType', tenantType);
    }

    return this.http.get<TenantListResponse>(`${this.apiUrl}office_lease/tenants`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
  getTenantContractType(
    id: any
  ): Observable<TenantContractReferenceResponse> {

    return this.http.get<TenantContractReferenceResponse>(`${this.apiUrl}office_lease/tenants/${id}/contract_references`, {
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getTenantDetail(
    id: string | number,
    startDate?: string,
    endDate?: string
  ): Observable<TenantDetailResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<TenantDetailResponse>(`${this.apiUrl}office_lease/tenants/${id}`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }


  getTenantBuilding(
    id: string | number,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string,
    contractTypeId?: any
  ): Observable<TenantBuildingResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (contractTypeId !== null) params = params.set('filter', contractTypeId);


    return this.http.get<TenantBuildingResponse>(`${this.apiUrl}office_lease/tenants/${id}/building`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
}
